export type CsvColumn<T> = { header: string; value: (row: T) => string };

function escapeCell(value: string): string {
  if (!/[",\n\r]/.test(value)) return value;
  return `"${value.replace(/"/g, '""')}"`;
}

/** Serializes rows to CSV per RFC 4180: CRLF record separator, quotes around cells containing comma, quote, or newline, internal quotes doubled. */
export function toCsv<T>(rows: T[], columns: CsvColumn<T>[]): string {
  const headerRow = columns.map((col) => escapeCell(col.header)).join(",");
  const dataRows = rows.map((row) => columns.map((col) => escapeCell(col.value(row))).join(","));
  return [headerRow, ...dataRows].join("\r\n");
}

export function toCsvBlob<T>(rows: T[], columns: CsvColumn<T>[]): Blob {
  return new Blob([toCsv(rows, columns)], { type: "text/csv;charset=utf-8" });
}
